import React from 'react';
import { useField } from 'formik';
import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation';

export const DescriptionField: React.FC = () => {
  const [field, meta] = useField<string>({ name: 'description' });

  return (
    <FormField
      label={<Label>Description</Label>}
      control={<Textarea {...field} autoComplete={'off'} />}
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
